import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav'
import Row from 'react-bootstrap/Row'
import Tab from 'react-bootstrap/Tab'
import styles from './index.module.scss'

interface TabItem {
  key: string
  name: string
}
interface Props {
  tabs: TabItem[]
  value?: string
  onChange: (key: string | null) => void
}

function Tabs({ tabs = [], value, onChange }: Props) {
  if (tabs?.length <= 2) return null
  return (
    <div className={styles.tabs}>
      <Tab.Container id="left-tabs-example" onSelect={onChange} defaultActiveKey={value || tabs[0]?.key}>
        <Row>
          <Col sm={12}>
            <Nav variant="pills" className="flex-row">
              {tabs?.map((item) => (
                <Nav.Item key={item.key}>
                  <Nav.Link eventKey={item.key}>{item.name}</Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
        </Row>
        {/* <Row style={{ marginTop: '24px' }}>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <h3>Tab 1 Content</h3>
                <p>Some content.</p>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <h3>Tab 2 Content</h3>
                <p>Some more content.</p>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row> */}
      </Tab.Container>
    </div>
  )
}

export default Tabs
